import React from 'react';
import './about.css';
import NavBar from '../../componets/navbar/navbar.js'
import AboutUs from '../../componets/aboutUs/aboutUs'
import Awards from '../../componets/awards/awards'
import Presentations from '../../componets/presentations/presentations'
import Publications from '../../componets/publications/publications'
import Teams from '../../componets/teams/teams'
class About extends React.Component {
    constructor(props) {
      super(props);
      this.getDetail = this.getDetail.bind(this);
      // To use the 'this' keyword, we need to bind it to our function
    }


    getDetail(id){
        if(id==='aboutUs'){
            return <AboutUs/>
        } else if ( id === 'awards'){
            return <Awards/>
        } else if ( id === 'talks'){
            return <Presentations/>
        }
        else if ( id === 'publications'){
            return <Publications/>
        }
        else if ( id === 'team'){
            return <Teams/>
        }
        return <AboutUs/>
    }
    render(){ 
        const { detail } = this.props.match.params;
        return (
            <div className='about'>
                <NavBar/>
                {this.getDetail(detail)}
            </div>
        )
    }

}

export default About;